type DeepReadonly<T> = T extends (infer U)[]
  ? ReadonlyArray<DeepReadonly<U>>
  : T extends object
    ? { readonly [K in keyof T]: DeepReadonly<T[K]> }
    : T;

export const deepFreeze = <T>(obj: T): DeepReadonly<T> => {
  if (obj === null || typeof obj !== "object") {
    throw new Error("deepFreeze can only be called on objects");
  }
  Object.freeze(obj);

  Object.values(obj).forEach((value) => {
    if (value && typeof value === "object" && !Object.isFrozen(value)) {
      deepFreeze(value);
    }
  });

  return obj as DeepReadonly<T>;
};
